import React from 'react';
import { UseEsriIdentityResult } from './hooks/use-esri-identity';

export const EsriIdentityContext = React.createContext<UseEsriIdentityResult | undefined>(
    undefined
);

/**
 * Reads the full Esri identity state/API (webMapPortalId, refreshCredential, getEsriToken, ...).
 * Must be read from within EsriConfiguration's subtree.
 */
export function useEsriIdentityContext(): UseEsriIdentityResult {
    const identity = React.useContext(EsriIdentityContext);
    if (!identity) {
        throw new Error('Unexpectedly did not find EsriIdentity on context.');
    }
    return identity;
}
